import { useDispatch, useSelector } from "react-redux";
import { SmallPlatformIcon } from "../platformsIcon";
import { PLATFORM_LIST } from "../../../../config/constants";
import {
  addActivePlatformTemp,
  removeActivePlatformTemp,
  toggleActivePlatformTemp,
} from "../../../../redux/slices/lomavisCreator/lomavisCreator";
import { isLocationSelected, isPlatformActive } from "./utils";

const LocationRow: React.FC<any> = ({ location, key }: any) => {
  const dispatch = useDispatch();

  // Using useSelector at the top level of the component
  const creatorMultipostConfig = useSelector(
    (state: any) => state.lomavisCreator.tempState.creator_multipost_config
  );
  const { locations } = useSelector((state: any) => state.locationsList);
  const selectLocation = (locationUUID) => {
    const toggleFunction = isLocationSelected(
      locationUUID,
      creatorMultipostConfig
    )
      ? removeActivePlatformTemp
      : addActivePlatformTemp;
    // get platforms from location
    //find location by uuid
    const location = locations.find((loc) => loc.uuid === locationUUID);
    if (!location) return;
    PLATFORM_LIST.map((platform) => {
      // check  is_platform_linked on location
      if (location?.[`is_${platform}_linked`])
        dispatch(
          toggleFunction({
            locationUUid: locationUUID,
            platform,
          })
        ) as any;
    });
  };
  return (
    <div
      className="w-100 d-flex cursor-pointer"
      key={key}
      onClick={() => selectLocation(location.uuid)}
    >
      <div
        className={`card card-stretch mb-3 px-3 py-1 profileGroupCard col-12 d-flex flex-column border selectedProfileGroup ${
          isLocationSelected(location.uuid, creatorMultipostConfig)
            ? "border-success border-2"
            : "border-secondary"
        }`}
      >
        <div className="">
          <i
            className={`fa-duotone fa-circle-check profileGroupCardSelected text-success ${
              isLocationSelected(location.uuid, creatorMultipostConfig)
                ? ""
                : "d-none"
            }`}
          ></i>
          <i
            className={`fa-regular fa-circle profileGroupCardDeselected ${
              isLocationSelected(location.uuid, creatorMultipostConfig)
                ? "d-none"
                : ""
            }`}
          ></i>
        </div>
        <div className="d-flex flex-row">
          <div className="col-6 d-flex flex-row mb-2">
            <div className="ms-2" style={{ width: "90%" }}>
              <h4 className="text-truncate mb-0">{location.name}</h4>
            </div>
          </div>
          <div className="col-6 d-flex align-items-center flex-row and a flex-wrap">
            {PLATFORM_LIST.map((platform) => {
              if (location?.[`is_${platform}_linked`])
                return (
                  <div className="me-2">
                    <SmallPlatformIcon
                      key={platform}
                      platform={platform}
                      active={isPlatformActive(
                        creatorMultipostConfig,
                        location.uuid,
                        platform
                      )}
                      onClick={(event) => {
                        // stop the event from going to the parent div
                        event.stopPropagation();

                        dispatch(
                          toggleActivePlatformTemp({
                            locationUUid: location.uuid,
                            platform,
                          })
                        ) as any;
                      }}
                    />
                  </div>
                );
            })}
          </div>
        </div>
        <div className="d-flex flex-row">
          <div className="col-12">
            {location?.tags?.map((tag) => {
              return (
                <span
                  className="badge badge-light me-1"
                  key={tag.uuid}
                  style={{
                    color: tag.text_color,
                    backgroundColor: tag.bg_color,
                  }}
                >
                  {tag.text}
                </span>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationRow;
